export const GET_VIRTUAL_POS='GET_VIRTUAL_POS'
export const GET_VIRTUAL_POS_SUCCESS='GET_VIRTUAL_POS_SUCCESS'
export const GET_VIRTUAL_POS_ERROR='GET_VIRTUAL_POS_ERROR'

export const GetVirtualPos = (data) => ({
    type: GET_VIRTUAL_POS,
    payload: data
})